module.exports = __webpack_public_path__ + "static/media/ettercap.5db45e1d.png";